module.exports = __webpack_public_path__ + "img/prof.539fae6a.png";